import { mutator } from 'satcheljs';
import { setSelectionOnRow } from 'owa-mail-actions/lib/mailListSelectionActions';
import { getStore } from 'owa-mail-list-store/lib/store/Store';
export default mutator(setSelectionOnRow, function (actionMessage) {
    var rowKey = actionMessage.rowKey, tableViewId = actionMessage.tableViewId, shouldSelect = actionMessage.shouldSelect;
    var tableView = getStore().tableViews.get(tableViewId);
    if (shouldSelect) {
        tableView.selectedRowKeys.set(rowKey, true);
    }
    else {
        tableView.selectedRowKeys.delete(rowKey);
    }
});
//# sourceMappingURL=setSelectionOnRowMutator.js.map